/* eslint-disable no-underscore-dangle */
import $ from 'jquery';
import PlayerFactory from '../models/PlayerFactory';
import isMobile from '../../utils/isMobile';
import JPlayer from './JPlayer';
import JPlayerMobilePlayer from './JPlayerMobilePlayer';

/**
 * See JPlayer documentation for information on these configuration options:
 *  http://jplayer.org/latest/developer-guide/#jPlayer-constructor
 */
const JPlayerConfiguration = {
  swfPath:
    'https://ajax.cdnjs.com/ajax/libs/jplayer/2.9.2/jplayer/jquery.jplayer.swf',
  mobile: {
    supplied: 'mp3,m4a,oga,m3u8a,m3ua',
    solution: 'html',
  },
  desktop: {
    supplied: 'mp3,m4a,oga,rtmpa,m3u8a,m3ua',
    solution: 'html,flash',
  },
};

function createJPlayerLibrary(config) {
  const containerElement = document.createElement('div');
  containerElement.setAttribute(
    'style',
    'width: 0px; height: 0px; display: none;',
  );
  document.body.appendChild(containerElement);
  const jPlayerInstance = $(containerElement).jPlayer(config);

  return {
    jPlayerInstance,
    mediaElement: containerElement.querySelector('audio'),
  };
}

export default class JPlayerFactory extends PlayerFactory {
  constructor() {
    super();
    this.jPlayerMobileInstance = null;
  }

  createPlayer() {
    const playerConfig = {
      swfPath: JPlayerConfiguration.swfPath,
    };

    if (!isMobile()) {
      playerConfig.supplied = JPlayerConfiguration.desktop.supplied;
      playerConfig.solution = JPlayerConfiguration.desktop.solution;
      const jPlayerConfig = createJPlayerLibrary(playerConfig);
      return new JPlayer(jPlayerConfig);
    }

    if (this.jPlayerMobileInstance) {
      return this.jPlayerMobileInstance;
    }

    playerConfig.supplied = JPlayerConfiguration.mobile.supplied;
    playerConfig.solution = JPlayerConfiguration.mobile.solution;
    const jPlayerConfig = createJPlayerLibrary(playerConfig);
    this.jPlayerMobileInstance = new JPlayerMobilePlayer(jPlayerConfig);
    return this.jPlayerMobileInstance;
  }
}
